// iter248 — send a group invite from the SYSTEM's Meta WhatsApp number.
import api from './api';

export async function sendSystemWaInvite(groupId, phone, name = '') {
  const res = await api.post(`/groups/${groupId}/invite/whatsapp`, {
    phone,
    name,
    origin: window.location.origin,
  });
  return res.data;
}
